import { useEffect, useRef } from "react";
import { mixUrl, takeChannel } from "@/lib/audioPool";
import { useGuidedTour } from "@/lib/guidedTour";

const LOUD = 0.14;
const DUCKED = 0.05;

// Soft looping ambient bed under the whole guided tour; ducks while the narrator speaks.
export default function TourMusicBed({ url, enabled }) {
  const { isActive, speaking } = useGuidedTour();
  const ref = useRef(null);
  const on = isActive && enabled && !!url;

  useEffect(() => {
    if (!on) return undefined;
    // Level is baked into the file (iOS ignores volume); element volume only ducks relative to it.
    const h = takeChannel("bed", mixUrl(url, LOUD), { loop: true, volume: DUCKED / LOUD });
    ref.current = h.el;
    h.play().catch(() => {});
    return () => { h.release(); ref.current = null; };
  }, [on, url]);

  useEffect(() => {
    const a = ref.current;
    if (!a) return undefined;
    const target = speaking ? DUCKED / LOUD : 1;
    const id = setInterval(() => {
      const d = target - a.volume;
      if (Math.abs(d) < 0.01) { a.volume = target; clearInterval(id); } else a.volume += d * 0.25;
    }, 60);
    return () => clearInterval(id);
  }, [speaking, on]);

  return null;
}
